module.exports = __webpack_public_path__ + "img/achievement-step-3-en.dc243f50.png";